import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FileSystemFileEntry, NgxFileDropEntry, NgxFileDropModule } from 'ngx-file-drop';

import { ProductsService } from '../../services/products.service';
import { Utils } from '../../services/utils.service';

import { SHARED_MODULES } from '../../../shared.';
import { SanitizerPipe } from '../../pipes/sanitizer.pipe';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { PhButtonComponent } from '../ph-button/ph-button.component';
import { PhIconComponent } from '../ph-icon/ph-icon.component';
import { PhLoaderComponent } from '../ph-loader/ph-loader.component';

const containerWidth: number = 213, containerHeight: number = 168;

interface ProductPhotoSelect {
    id: number;
    name: string;
    barcode: string;
    width: number;
    height: number;
}

@Component({
    selector: 'app-upload-photo',
    templateUrl: './upload-photo.component.html',
    styleUrls: ['./upload-photo.component.scss'],
	imports: [
		SHARED_MODULES,
		NgxFileDropModule,
		SanitizerPipe,
		FaIconComponent,
		PhButtonComponent,
		PhIconComponent,
		PhLoaderComponent
	],
    standalone: true
})
export class UploadPhotoComponent implements OnInit {
    product: ProductPhotoSelect;
    photo: any;
    uploadedImage: File;
    uploadedImageUrl: string;
    imageType: string;
    googleImages: string[] = [];
    googleIndex: number;
    googleNoResults: boolean = false;

    previewWidth: number;
    previewHeight: number;
    loader: boolean = false;
	title: string = '';

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<UploadPhotoComponent>,
        private Products: ProductsService
    ) {
        this.product = data.product;
        this.photo = data.photo;
		this.title = data.title;

        this.setPreviewSizes();
    }

    ngOnInit() {}

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    async apply() {
        if (this.imageType == 'google') {
            this.photo = this.googleImages[this.googleIndex];
        }
        if (this.imageType == 'file') {
            let reader = new FileReader();
            reader.readAsDataURL(this.uploadedImage);
            reader.onload = async () => {
                this.photo = reader.result;
                this.dialogRef.close(this.photo);
            };
        } else {
            this.dialogRef.close(this.photo);
        }
    }

    cancel(): void {
        this.dialogRef.close(false);
    }

    chooseFile(files: NgxFileDropEntry[]) {
        if (!files.length || !files[0].fileEntry.name || !Utils.bruteCheckFileExtension(files[0].fileEntry.name)) return;

        (files[0].fileEntry as FileSystemFileEntry).file((file: File) => {
            this.imageType = 'file';
            this.uploadedImage = file;
            this.uploadedImageUrl = URL.createObjectURL(file);
        });
    }

    onGoogleColumnClick(): void {
        if (this.loader || this.imageType === 'google') {
            return;
        }
        void this.google();
    }

    async google() {
        this.loader = true;
        this.googleNoResults = false;
        const raw = await this.Products.googleImages(this.product.name, this.product.barcode);
        this.loader = false;
        const urls = this.Products.normalizeGoogleImagesResponse(raw);
        if (!urls.length) {
            this.googleNoResults = true;
            this.googleImages = [];
            return;
        }
        this.googleImages = urls;
        this.imageType = 'google';
        this.googleIndex = 0;
    }

    googlePrev() {
        if (this.googleIndex == 0) {
            this.googleIndex = this.googleImages.length - 1;
        } else {
            this.googleIndex--;
        }
    }

    googleNext() {
        if (this.googleIndex == this.googleImages.length - 1) {
            this.googleIndex = 0;
        } else {
            this.googleIndex++;
        }
    }

    setPreviewSizes() {
		if (!this.product) return;
        if (this.product.width / this.product.height > containerWidth / containerHeight) {
            this.previewWidth = containerWidth;
            this.previewHeight = Math.round(containerWidth * this.product.height / this.product.width);
        } else {
            this.previewHeight = containerHeight;
            this.previewWidth = Math.round(containerHeight * this.product.width / this.product.height);
        }
    }
}
